<div class="flex flex-col gap-5">
  <div class="flex items-start justify-between gap-4">
    <div>
      <h3 class="text-color text-xl font-bold leading-7">{{ title }}</h3>
      @if (subtitle) {
        <p class="subtext-color text-base mt-0.5">{{ subtitle }}</p>
      }
    </div>

    @if (showFilter && periodOptions.length) {
      <l-dashboard-period-filter
        [options]="periodOptions"
        [(selectedValue)]="selectedPeriod"
        [shortDisplay]="variant === 'lessons'"
        (selectedValueChange)="selectedPeriodChange.emit($event)"
      />
    }
  </div>

  @if (variant === 'lessons') {
    <div class="w-full">
      <div class="grid grid-cols-[1fr_auto] gap-x-6 text-base subtext-color light:!text-lWhite pb-3 border-b border-lGray800 light:border-lGray700">
        <span>{{ nameColumnLabel }}</span>
        <span class="text-right">{{ valueColumnLabel }}</span>
      </div>

      <div class="flex flex-col gap-2 pt-3">
        @for (item of items; track item.position) {
          <div
            class="px-4 py-3"
            [class.bg-lGray850]="item.position === 1"
            [class.light:bg-lRankingHighlight]="item.position === 1"
            [class.rounded-xl]="item.position === 1"
          >
            <div class="grid grid-cols-[1fr_auto] gap-x-6 items-center">
              <div class="flex items-center gap-3 min-w-0">
                @if (item.position === 1) {
                  <span class="w-8 h-8 rounded-xl bg-gradient-primary flex items-center justify-center shrink-0">
                    <l-icon class="text-white text-lg leading-none">emoji_events</l-icon>
                  </span>
                } @else {
                  <span class="w-8 h-8 rounded-xl bg-lGray700 light:bg-lRankingHighlight flex items-center justify-center text-sm text-lWhite light:text-white font-medium shrink-0">
                    {{ item.position }}º
                  </span>
                }

                <span class="text-color text-base font-medium truncate" [ngClass]="{ 'light:!text-white': item.position === 1 }">{{ item.name }}</span>
              </div>

              <span class="text-color text-base font-semibold" [ngClass]="{ 'light:!text-white': item.position === 1 }">{{ formatValue(item) }}</span>
            </div>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="w-full">
      <div class="grid grid-cols-[1fr_auto] gap-x-6 text-base subtext-color light:!text-lWhite pb-3 light:border-b light:border-lGray700">
        <span>{{ nameColumnLabel }}</span>
        <span class="text-right">{{ valueColumnLabel }}</span>
      </div>

      <div class="flex flex-col gap-4 pt-1 light:pt-4">
        @for (item of items; track item.position) {
          <div class="flex flex-col gap-2.5">
            <div class="grid grid-cols-[1fr_auto] gap-x-6 items-center">
              <span class="text-color text-base font-medium truncate">{{ item.name }}</span>
              <span class="text-color text-base font-semibold">{{ formatValue(item) }}</span>
            </div>

            @if (showProgressBars) {
              <l-dashboard-progress-bar
                [value]="getBarValue(item)"
                [maxValue]="getBarMax(item)"
                heightClass="h-4"
              />
            }
          </div>
        }
      </div>
    </div>
  }
</div>
